import NewArrivals from "./NewArrivals";

function Swim(){
    return(
        <div>
            <NewArrivals/>
        </div>
    )
}
export default Swim;